// Item-Typen
export const ITEM_TYPES = [
  { value: 'Waffe', label: '⚔️ Waffe' },
  { value: 'Ruestung', label: '🛡️ Rüstung' },
  { value: 'Schuhe', label: '👢 Schuhe' },
  { value: 'Trank', label: '🧪 Trank' },
  { value: 'Schmuck', label: '💍 Schmuck' },
  { value: 'Schriftrolle', label: '📜 Schriftrolle' },
  { value: 'Werkzeug', label: '🔧 Werkzeug' },
  { value: 'Schluessel', label: '🔑 Schlüssel' },
  { value: 'Gold', label: '🪙 Gold' },
  { value: 'Sonstiges', label: '📦 Sonstiges' }
];

// Zauber-Typen
export const SPELL_TYPES = [
  { value: 'Feuer', label: '🔥 Feuer' },
  { value: 'Eis', label: '❄️ Eis' },
  { value: 'Blitz', label: '⚡ Blitz' },
  { value: 'Natur', label: '🌿 Natur' },
  { value: 'Dunkel', label: '💀 Dunkel' },
  { value: 'Licht', label: '💖 Licht' },
  { value: 'Arkan', label: '🔮 Arkan' },
  { value: 'Heilung', label: '💗 Heilung' }
];
